declare global {
  namespace JSX {
    interface IntrinsicElements {
      'kia-prislista-business': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
  interface Window {
    grecaptcha: typeof grecaptcha;
  }
}

import TrimType = App.Models.Car;
import ModelType = App.Models.CarModel;
import FuelType = App.Models.Type;
import CategoryType = App.Models.Category;
import DisclaimerType = App.Models.Disclaimer;
import Specification = App.Models.Specification;
import FinancialLeasingType = App.Models.FinancialLeasing;
import BusinessLeasingType = App.Models.BusinessLeasing;

export enum FinanceOption {
  PRIVATE = 'Privatleasing',
  LOAN = 'Billån',
  BUSINESS = 'Business lease',
}

export enum BusinessDistance {
  One = '1500 mil',
  Two = '2000 mil',
  Three = '3000 mil',
  Four = '4000 mil',
}

export enum PrivateDistance {
  One = '1000 mil',
  Two = '1500 mil',
  Three = '2000 mil',
  Four = '3000 mil',
}

export enum TypeOfLeasing {
  BUSINESS = 'Kia Business Lease⁵⁾',
  FINANCIAL = 'Kia Finansiell Leasing⁶⁾',
}

export type {
  BusinessLeasingType,
  CategoryType,
  DisclaimerType,
  FinancialLeasingType,
  FuelType,
  ModelType,
  Specification,
  TrimType,
};
